/**
 * One label per act for "a person reviewed this AI-authored item" (Doc 30
 * creation provenance) — the item view, the bulk bar, the Classification app
 * and Voice attribution all say the same words for approve_ai_item /
 * unreview_ai_item.
 */
export const MARK_REVIEWED_LABEL = 'Mark as reviewed';
export const MARKING_REVIEWED_LABEL = 'Marking as reviewed…';
export const MARK_NOT_REVIEWED_LABEL = 'Mark as not reviewed';
/**
 * Drawn in place of Mark as reviewed for someone approve_ai_item (migration 735)
 * would refuse: it takes a workspace admin or owner, or the
 * items.approve_ai_provenance permission (build contract §2.8).
 */
export const MARK_REVIEWED_REFUSED_LINE =
  'Marking this as reviewed takes a workspace admin or someone with the Approve AI-Drafted Items permission.';
